import { RoundDetailPlayButtonText } from "@/pages/Rounds/constant";
import { PlayIcon } from "@roman/shared/components/Icons";
import { Link } from "react-router-dom";

export const RoundDetailButton = ({ detailUrl }: { detailUrl: string }) => {
  return (
    <Link to={detailUrl} state={{ roundDetailPlayButtonText: RoundDetailPlayButtonText.Enter }}>
      <button
        type="button"
        className="px-2 absolute bottom-1.5 left-1/2 transform -translate-x-[50%] flex items-center space-x-1 rounded-full border-[1px] bg-white border-secondary"
      >
        <span className="align-middle text-[8.5px] text-primary font-bold leading-[14px] py-[3px]">大会情報を確認</span>
        <span>
          <PlayIcon className="text-primary" />
        </span>
      </button>
    </Link>
  );
};
